module.exports = __webpack_public_path__ + "static/media/view_po_1.59dd1ebe.png";